import {RootStoreState} from '../../stores/RootStoreState';

export const getSelectionIds = (state: RootStoreState): number[] => {
  return Object.values(state.selectionInput).filter((selectionId) => selectionId != null);
};
